// Pure formatters for the prices table. Isolated from the component so the
// API-shape contract (null cells, per-month strings) is easy to reason about/test.

// formatMoney returns "<symbol><value>" or "—" for a missing price. null/undefined AND 0
// are treated as gaps (the spec makes 0 a missing-price sentinel; no real plan costs 0), so
// a stray 0 renders "—" rather than a misleading "$0".
export function formatMoney(symbol, value) {
  if (value === null || value === undefined || value === 0) return '—';
  return `${symbol}${value}`;
}

// formatSessionPrice formats the per-extra-session price. Unlike the term totals (whole dollars),
// this can carry cents — e.g. 14.5 -> "$14.50", 13.25 -> "$13.25" — while integers stay clean ("$23").
// null/undefined/0 render "—" (missing/ineligible; GC and Platform Access have no extra-session price).
// session_price_60 = ROUND(price/spw)/4, so it is always a multiple of $0.25 — toFixed(2) is exact
// here (no float half-rounding ambiguity, which would only arise for 3rd-decimal values).
export function formatSessionPrice(symbol, value) {
  if (value === null || value === undefined || value === 0) return '—';
  const str = Number.isInteger(value) ? String(value) : value.toFixed(2);
  return `${symbol}${str}`;
}

// cellHalf returns display strings for one offer-state half of a cell.
// perMonth is null (no line rendered) when the source per-month is absent (null/undefined/0).
export function cellHalf(symbol, total, perMonth) {
  const hasPerMonth = perMonth !== null && perMonth !== undefined && perMonth !== 0;
  return {
    total: formatMoney(symbol, total),
    perMonth: hasPerMonth ? `${formatMoney(symbol, perMonth)}/mo` : null
  };
}
